var configs = {
    insertMethod: 'append',
    insertSelector: 'body'
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/fixedelements/_configs.js
// module id = 462
// module chunks = 0